import axios from "axios";
import api from "../api"

export default {

    UPDATE_TICKET: (ticketId, data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.put(
                    process.env.REACT_APP_BACKEND_URL + api.support.UPDATE_TICKET(ticketId),
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },

    uploadFile: (id, formData) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_BACKEND_URL + api.support.uploadFile(id),
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },

    uploadSingleFile: (formData) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_BACKEND_URL + "/template/singleImage",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },

    createTicket: (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_BACKEND_URL + api.support.createTicket(),
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },

    getUserTickets: (userId, params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.getUserTickets(userId),
                    { params }
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },

    getAllTickets: (params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.getAllTickets(),
                    { params }
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },

    GETALLBOARD: (params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.GETALLBOARD(),
                    { params }
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },



    SELECTED_BOARD: (id, params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.SELECTED_BOARD(id),
                    { params }
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },
    getTicketById: (ticketId) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.getTicketById(ticketId)
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },

    replyToTicket: (ticketId, data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.put(
                    process.env.REACT_APP_BACKEND_URL + api.support.replyToTicket(ticketId),
                    data
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },

    GET_ALL_USER: (params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const queryParams = new URLSearchParams(params).toString();
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + `/auth/getAllUser?${queryParams}`
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    },

    GET_BOARD_USERS: (params = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_BACKEND_URL + api.support.GET_BOARD_USERS(),
                    { params }
                );
                resolve(response.data);
            } catch (err) {
                reject(err);
            }
        });
    }
};
